'use strict';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _button = require('common/components/button');

var _button2 = _interopRequireDefault(_button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function FAQ(p) {
    return _react2['default'].createElement(
        'div',
        { className: 'seo-cloud-integrations__faq' },
        _react2['default'].createElement(
            'p',
            null,
            'Questions about this integration? We have answers.'
        ),
        _react2['default'].createElement(_button2['default'], {
            buttonText: 'View our FAQ',
            buttonLink: p.link,
            buttonColor: 'cerulean',
            openInNewWindow: true })
    );
}

module.exports = FAQ;


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/components/common/faq-section.jsx
 ** module id = 1247
 ** module chunks = 0
 **/